import { ReactNode } from 'react';

import classes from 'components/common/Tables/Cells/TitleAndSubTitle/TitleAndSubTitle.module.scss';

interface Props {
    title: string | ReactNode;
    subTitle: string;
}

export const TitleAndSubTitle = ({ title, subTitle }: Props) => {
    return (
        <div className={classes.titlesComponent}>
            <span className={classes.title}>{title}</span>
            <span className={classes.subTitle}>{subTitle}</span>
        </div>
    );
};
